/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateLabelRequestLabelFromJSON, UpdateLabelRequestLabelToJSON } from './UpdateLabelRequestLabel';
export function UpdateLabelRequestFromJSON(json) {
    return UpdateLabelRequestFromJSONTyped(json, false);
}
export function UpdateLabelRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        label: !exists(json, 'label') ? undefined : UpdateLabelRequestLabelFromJSON(json['label'])
    };
}
export function UpdateLabelRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        label: UpdateLabelRequestLabelToJSON(value.label)
    };
}
